import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../i18n/LanguageContext';

const CTAContainer = styled.section`
  position: relative;
  padding: 110px 20px;
  background: linear-gradient(135deg, var(--primary) 0%, #1c6be1 45%, #62a4ff 100%);
  color: #fff;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 90px 18px;
  }

  @media (max-width: 480px) {
    padding: 74px 16px;
  }
`;

const Glow = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(112, 191, 255, 0.35), transparent 55%),
    radial-gradient(circle at 80% 30%, rgba(255, 255, 255, 0.22), transparent 48%);
  opacity: 0.9;
`;

const ContentWrapper = styled.div`
  position: relative;
  max-width: 860px;
  margin: 0 auto;
  text-align: center;
  z-index: 1;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 3.2vw, 3rem);
  margin-bottom: 18px;
  font-weight: 700;

  @media (max-width: 480px) {
    line-height: 1.25;
  }
`;

const Description = styled.p`
  font-size: 1.05rem;
  margin-bottom: 46px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.84);

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 38px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 18px;
`;

const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 15px 34px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 15px;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  background: ${props => props.$primary ? '#ffffff' : 'transparent'};
  color: ${props => props.$primary ? 'var(--primary)' : '#ffffff'};
  border: ${props => props.$primary ? 'none' : '2px solid rgba(255, 255, 255, 0.65)'};
  box-shadow: ${props => props.$primary ? '0 20px 40px rgba(15, 23, 42, 0.24)' : 'none'};
  letter-spacing: 0.02em;

  &:hover {
    transform: translateY(-3px);
    box-shadow: ${props => props.$primary ? '0 26px 50px rgba(15, 23, 42, 0.25)' : '0 18px 40px rgba(15, 23, 42, 0.2)'};
    background: ${props => props.$primary ? '#f8f8f8' : 'rgba(255, 255, 255, 0.12)'};
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const CTASection = () => {
  const { t } = useLanguage();
  return (
    <CTAContainer>
      <Glow />
      <ContentWrapper>
        <Title>{t('home.cta.title')}</Title>
        <Description>{t('home.cta.description')}</Description>
        <ButtonContainer>
          <Button $primary href="/quote">{t('home.cta.primary')}</Button>
          <Button href="/contact">{t('home.cta.secondary')}</Button>
        </ButtonContainer>
      </ContentWrapper>
    </CTAContainer>
  );
};

export default CTASection;